import { render, staticRenderFns } from "./DashboardAdminPortal.vue?vue&type=template&id=082572f6&scoped=true"
import script from "./DashboardAdminPortal.vue?vue&type=script&lang=js"
export * from "./DashboardAdminPortal.vue?vue&type=script&lang=js"
import style0 from "./DashboardAdminPortal.vue?vue&type=style&index=0&id=082572f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082572f6",
  null
  
)

export default component.exports